import { Link } from "react-router-dom";

const RETURNS = [
  {
    icon: "ri-price-tag-3-line",
    label: "Nightly Rental Revenue",
    value: "₹7,000 – ₹15,000+",
    hint: "Per villa per night",
  },
  {
    icon: "ri-calendar-check-line",
    label: "Occupancy Potential",
    value: "60% – 80%",
    hint: "Year-round demand",
  },
  {
    icon: "ri-bank-card-line",
    label: "Annual Revenue Potential",
    value: "₹12 – 30 Lakhs+",
    hint: "Per villa per year",
  },
];

export default function Returns() {
  return (
    <section id="returns" className="relative w-full py-16 md:py-24 bg-background-50 overflow-hidden">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
            <i className="ri-money-rupee-circle-line"></i> Income &amp; Return Potential
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-4 leading-tight">
            Returns That <span className="italic text-primary-700">Compete With Premium Real Estate</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
            Strong nightly rates, healthy occupancy and multiple revenue drivers combine to
            deliver attractive, recurring annual returns.
          </p>
          <Link
            to="/returns"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-primary-600 text-primary-700 px-5 py-2.5 hover:bg-primary-600 hover:text-background-50 transition-colors"
          >
            Explore Return Potential
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-10 md:mt-14">
          {RETURNS.map((stat) => (
            <div
              key={stat.label}
              className="relative rounded-2xl bg-background-100 border border-background-200 p-6 md:p-8 text-center"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-accent-100 text-accent-700">
                <i className={`${stat.icon} text-xl`}></i>
              </span>
              <p className="text-[11px] uppercase tracking-wide text-foreground-600 mt-4">
                {stat.label}
              </p>
              <p className="font-heading text-2xl md:text-4xl font-semibold text-primary-700 mt-2 leading-tight">
                {stat.value}
              </p>
              <p className="text-xs text-foreground-600 mt-2">{stat.hint}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}